import classNames from "classnames";
import React from "react";
import styles from "./SiteSection.scss";

/**
 * Content section on a public page: page-width column with vertical spacing
 * @param spacing – "large" (default, 80px / 64px on phones), "medium" (56px) or "small" (32px)
 * @param label – accessible name (aria-label), for sections without a visible heading
 * @param labelledBy – id of the element naming the section (aria-labelledby)
 */
export const SiteSection = ({ spacing = "large", id, label, labelledBy, className, children }) => {
    return (
        <section
            id={id}
            aria-label={label}
            aria-labelledby={labelledBy}
            className={classNames(
                styles.base,
                {
                    [styles.spacingSmall]: spacing === "small",
                    [styles.spacingMedium]: spacing === "medium",
                    [styles.spacingLarge]: spacing === "large"
                },
                className
            )}
        >
            {children}
        </section>
    );
};
